import * as React from 'react';
import autobind from 'autobind-decorator';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


//interfaces
import { ICourseGroup, IGroupConcept, ICourseGC } from 'store/StateInterfaces';

//Components
import GenericForm from '../Components/GenericForm';
import Group from '../Components/Group';

//Assets 
import { Row, Col, Container, Button, Accordion } from 'react-bootstrap';
import { FiPlusCircle } from 'react-icons/fi';
import { IoMdCloudUpload } from 'react-icons/io';
import { MdImportExport } from 'react-icons/md';

// actions
import {
    loadCourseGroupsRequest,
    addCourseGroupRequest,
    deleteCourseGroupRequest,
    editCourseGroupRequest,
    reorderCourseGroupsRequest,
    reorderGlobalRequest,
} from '../Actions/Actions';

// dragula for reordering
import * as dragula from 'dragula';
import 'dragula/dist/dragula.css';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';

// Assets
import '../Assets/CoursePlayListInstructorPage.sass';

interface IProps {
    courseid: any;
    groupid: any;
    loaded: boolean;
    groups: Array<ICourseGroup>;
    actions: any;
};
interface IState {
    showform: boolean;
    showMessage: boolean;
    order: boolean;
    orderGlobal: boolean;
}

class CoursePlaylist extends React.Component<IProps, IState> {
    private dragulaService: any;
    private groupsCopy: any;
    private idToGroup: any;
    private groupConcepts: any;
    private reorderTransitions: Array<any>;

    constructor(props: IProps) {
        super(props);
        this.state = {
            showform: false,
            showMessage: false,
            order: false,
            orderGlobal: false
        };
    }
    @autobind
    public addgroupform() {
        this.setState({
            showform: true,
            showMessage: false
        });
    }

    @autobind
    public addGroup(data: { title: string, description: string }) {

        this.props.actions.addCourseGroupRequest(this.props.courseid, data)
            .then(res => {
                this.setState({
                    showform: false,
                    showMessage: true
                })
            })
            .catch(err => console.log(err));

    }

    @autobind
    public handleEditGroup(groupid: number, data: FormData) {

        return this.props.actions.editCourseGroupRequest(this.props.courseid, groupid, data);
    }

    @autobind
    closePanel(event) {
        this.setState({
            showform: false
        })
    }

    @autobind
    handleDeleteGroup(groupid) {
        if (confirm('Are you sure?'))
            this.props.actions.deleteCourseGroupRequest(this.props.courseid, groupid);
    }

    componentDidMount() {
        if (!this.props.loaded) {
            this.props.actions.loadCourseGroupsRequest(this.props.courseid);
        }
    }

    @autobind
    public saveOrder() {
        const playlist = this.groupsCopy.map(g => g.id);
        const formData = new FormData();
        formData.append('playlist', JSON.stringify(playlist));
        this.props.actions.reorderCourseGroupsRequest(this.props.courseid, formData, this.groupsCopy)
            .catch(err => {
                this.props.actions.loadCourseGroupsRequest(this.props.courseid)
            })
            .then(res => {
                this.setState({ order: false })
            })
    }

    @autobind
    public handleOrder() {
        if (!this.state.order) {

            //store a copy 
            this.groupsCopy = [...this.props.groups];
            this.idToGroup = {};
            this.props.groups.forEach((g) => {
                this.idToGroup[g.id] = g;
            });

            this.dragulaService = dragula([document.getElementById(`groupListContainer`)], {
                revertOnSpill: true,
                moves: function (el, container, handle) {
                    console.log(handle);
                    return handle.classList.contains(`groupListHandle`);
                }
            }).on('drop', function (el, container, handle) {
                console.log('element', el);
                console.log('container', container);
                console.log('handle', handle);

                this.groupsCopy = Array.from(container.children).map(function (g) {
                    return this.idToGroup[g["id"]]
                }.bind(this))

            }.bind(this));
            this.setState({
                order: true
            });
        }
        else {
            this.dragulaService.destroy();
            this.saveOrder();
        }
    }


    @autobind
    public handleOrderGlobal() {
        if (!this.state.orderGlobal) {

            this.reorderTransitions = [];
            //store a copy for future use of cancel reorder
            this.groupConcepts = {};
            const containers = this.props.groups.map((g) => {
                return document.getElementById(`conceptListContainer-${g.id}`);
            })
            this.dragulaService = dragula(containers, {
                revertOnSpill: true,
                moves: function (el, container, handle) {
                    console.log(handle);
                    return handle.classList.contains(`conceptListHandle`);
                }
            }).on('drop', function (el, container, handle) {
                console.log('element', el);
                console.log('container', container);
                console.log('handle', handle);

                // update groupstate and transitions
                const srcId = (handle.id).split('-')[1];
                const dstId = (container.id).split('-')[1];
                const elemId = el['id'];

                // prashanth
                const transition = {
                    'srcGroupId': srcId,
                    'dstGroupId': dstId,
                    'conceptId': elemId
                }
                this.reorderTransitions.push(transition);
                this.groupConcepts[srcId] = Array.from(handle.children).map(c => c['id']);
                this.groupConcepts[dstId] = Array.from(container.children).map(c => c['id']);

                console.log('current order=>', this.groupConcepts);
                console.log('current transitions=> ', this.reorderTransitions);

            }.bind(this));
            this.setState({
                orderGlobal: true
            });
        }
        else {
            this.dragulaService.destroy();
            const payload = {
                'transitions': this.reorderTransitions,
                'newGroupStates': this.groupConcepts
            }
            this.props.actions.reorderGlobalRequest(this.props.courseid, payload);
            this.setState({
                orderGlobal: false
            })
        }
    }

    public render() {
        let message = null;
        let addgroupform = null;
        let groups = null;
        let courses_list = [];
        let to_import_groups = [];

        if (this.state.showMessage) {
            message = (
                <div className="alert alert-success alert-dismissable">
                    <button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                    You have successfully added the chapter at the bottom.
                </div>);
        }
        if (this.state.showform) {
            addgroupform = <GenericForm heading="Add Chapter" title="" description="" saveCallBack={this.addGroup}
                closeCallBack={this.closePanel} />;
        }
        if (!this.props.loaded) {
            groups = <p>Loading...</p>;
        }
        else {
            if (this.props.groups.length === 0) {
                groups = (
                    <div className="alert alert-danger alert-dismissable">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                        No content found in this course
                    </div>);
            }
            else {
                /* doubt */
                if (this.props.groupid == "" || this.props.groupid == undefined) {
                    groups = this.props.groups.map(
                        (group, i) => {
                            return <Group
                                orderParent={this.state.order}
                                orderChild={this.state.orderGlobal}
                                key={group.id} deleteCallBack={this.handleDeleteGroup} group={group} index={i}
                                editCallBack={this.handleEditGroup}
                            />;
                        }
                    );
                } else {
                    // var check = this.props.groupid;
                    groups = this.props.groups.map(
                        (group, i) => {
                            if (this.props.groupid == group.id) {
                                return <Group
                                    orderParent={this.state.order}
                                    orderChild={this.state.orderGlobal}
                                    key={group.id}
                                    deleteCallBack={this.handleDeleteGroup} group={group} index={i}
                                    editCallBack={this.handleEditGroup} />;
                            }
                        });
                    groups = groups.filter((n) => {
                        return n != undefined;
                    });
                    groups = groups[0];
                }
            }

        }


        return (
            <Container className="p-4 ml-3" style={{ border: "1px solid rgb(190,190,190)" }}>
                <Row className="d-flex align-items-center">
                    <Col md={{ span: 4 }}>
                        <h4 style={{ color: 'grey' }}>
                            Multimedia Book
                        </h4>
                    </Col>
                    <Col md={{ span: 8 }} className="text-right">
                        <Button
                            className="btn-sm mx-2 shadow"
                            onClick={this.addgroupform} >
                            <span>
                                <FiPlusCircle size={18} />{' '}
                                Add Chapter
                            </span>
                        </Button>
                        <Button variant="primary"
                            style={{ backgroundColor: 'white', color: 'black' }}
                            className="btn-sm"
                        >
                            <span>
                                <IoMdCloudUpload size={18} />{' '}
                                Import Content
                            </span>
                        </Button>
                    </Col>
                </Row>
                <hr
                    style={{
                        marginLeft: 5,
                        marginRight: 5,
                        height: '1px',
                        border: 'none',
                        backgroundColor: 'grey'
                    }}
                />
                <Row>
                    <Col md={{ span: 12 }} className="d-flex justify-content-between">
                        <Button
                            className="btn-sm"
                            onClick={this.handleOrderGlobal}
                            style={{ backgroundColor: 'white', color: 'black' }}
                        >
                            <span>
                                <MdImportExport size={18} />{' '}
                                {this.state.orderGlobal ? 'Save Order Global' : 'Reorder Global'}
                            </span>
                        </Button>
                        <Button variant="primary"
                            className="btn-sm"
                            onClick={this.handleOrder}
                            style={{ backgroundColor: 'white', color: 'black' }}
                        >
                            <span>
                                <MdImportExport size={18} />{' '}
                                {this.state.order ? 'Save Order' : 'Reorder'}
                            </span>
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col md={{ span: 12 }} className="my-3">
                        {addgroupform}
                    </Col>
                </Row>
                <Row>
                    <Col md={{ span: 12 }}>
                        {
                            this.state.order || this.state.orderGlobal ?
                                <Accordion activeKey="-1" id="groupListContainer">
                                    {groups}
                                </Accordion>
                                :
                                <Accordion defaultActiveKey="0" id="groupListContainer">
                                    {groups}
                                </Accordion>
                        }

                    </Col>
                </Row>

            </Container >

        );
    }
};




interface IReduxState {
    instructorCourseGC: ICourseGC;
}

const mapStateToProps = (state: IReduxState, { courseid, groupid }) => {
    let sGC = state.instructorCourseGC;
    if (sGC.instructorCourseGroupsMap.has(courseid)) {
        return {
            loaded: true,
            groups: sGC.instructorCourseGroupsMap.get(courseid),
            courseid,
            groupid
        }
    }
    else {
        return {
            loaded: false,
            groups: [],
            courseid,
            groupid
        }
    }
}


const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        loadCourseGroupsRequest,
        addCourseGroupRequest,
        deleteCourseGroupRequest,
        editCourseGroupRequest,
        reorderCourseGroupsRequest,
        reorderGlobalRequest
    }, dispatch)
})


export default connect(mapStateToProps, mapDispatchToProps)(CoursePlaylist);
